class SizeGuideModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('.size-guide-modal');

    this.buildMobileTable();

    this.onKeyDown = this.handleKeyDown.bind(this);
    this.onClick = this.handleOnClick.bind(this);
  }

  open() {
    const result = $s.openModal(this.modal, 'size-guide-table-wrapper');
    if (result && result.modal) {
      result.modal.setAttribute('aria-labelledby', 'size-guide-title');
    }
  }

  // Wide charts (sizes as columns) don't fit on phones, so add a flipped copy with sizes as rows.
  // CSS shows it below the mobile breakpoint and hides the original.
  buildMobileTable() {
    const table = this.modal && this.modal.querySelector('table');
    if (!table || table.rows.length < 2) return;
    const rows = [...table.rows];
    const colCount = rows[0].cells.length;
    if (colCount <= rows.length) return;

    const flipped = document.createElement('table');
    flipped.className = 'size-guide-mobile-table';
    const thead = flipped.createTHead().insertRow();
    rows.forEach((row, r) => {
      const th = document.createElement('th');
      const label = row.cells[0] ? row.cells[0].textContent.replace(/\u00a0/g, ' ').trim() : '';
      th.textContent = label || (r == 0 ? 'Size' : '');
      thead.appendChild(th);
    });
    const tbody = flipped.createTBody();
    for (let c = 1; c < colCount; c++) {
      const tr = tbody.insertRow();
      rows.forEach(row => {
        tr.insertCell().innerHTML = row.cells[c] ? row.cells[c].innerHTML : '';
      });
    }
    table.classList.add('size-guide-desktop-table');
    table.after(flipped);
  }

  close() {
    $s.closeModal();
  }

  isOpen() {
    return this.classList.contains('open');
  }

  handleKeyDown(e) {
    if (e.which == 27) { //Exit
      if(this.isOpen()){
        e.preventDefault();
        this.close();
        return false;
      }
    }
  }

  handleOnClick(e) {
    if(!this.contains(e.target)) {
      this.close();
    }
  }
}
customElements.define('size-guide-modal', SizeGuideModal);

// Delegated because triggers get moved and colour panels are built after load. There can be more than 1 when there's a Bundle.
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.size-guide-popup-trigger');
  if (!trigger) return;
  const panel = trigger.closest('.product-main-element');
  const guide = (panel && panel.querySelector('size-guide-modal')) || document.querySelector('size-guide-modal');
  if (!guide) return;
  e.preventDefault();
  guide.open();
});